import React, { useState } from 'react';
import styles from './manageRulesHeader.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import colors from 'src/styles/colors.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import { ButtonPrimary } from '@americanexpress/dls-react';
import { DLSSize } from 'src/types/dls-size.enum';
import Selectors from 'src/utils/selectors';
import RuleInfoModal from 'src/components/atomic/organisms/ruleInfoModal/RuleInfoModal';
import { WalkmePopupWrapper, WalkmeName } from 'src/components/atomic/organisms/walkme';
import CreateRuleBoxWrapper from 'src/components/atomic/organisms/createRuleBox/CreateRuleBox';

export default function ManageRulesHeader(): JSX.Element {
    const [isCreatingRule, setIsCreatingRule] = useState<boolean>(false);

    return (
        <div className={styles.manageRulesHeader} data-cy={Selectors.Transactions.MANAGE_RULES_HEADER}>
            <div className={styles.row}>
                <div className={styles.content}>
                    <Typography
                        component="h2"
                        variant={TypographyVariants.HEADING_S}
                        className={colors.brandStrong}
                        data-cy={Selectors.Transactions.MANAGE_RULES_HEADER_TITLE}
                    >
                        {LiteralsService.getLiteral('ManageRulesHeader.title')}
                    </Typography>
                    <Typography
                        component="p"
                        variant={TypographyVariants.BODY}
                        className={styles.description}
                        data-cy={Selectors.Transactions.MANAGE_RULES_HEADER_DESCRIPTION}
                    >
                        {LiteralsService.getLiteral('ManageRulesHeader.description')}
                    </Typography>
                    <RuleInfoModal />
                </div>
                <WalkmePopupWrapper walkmeName={WalkmeName.TRANSACTION_CLASSIFICATION} stepIndex={5}>
                    {!isCreatingRule && (
                        <ButtonPrimary
                            className={styles.createRuleButton}
                            size={DLSSize.MEDIUM}
                            data-cy={Selectors.Transactions.CREATE_RULE_BUTTON}
                            onClick={() => setIsCreatingRule(true)}
                        >
                            {LiteralsService.getLiteral('ManageRulesHeader.createRuleButton')}
                        </ButtonPrimary>
                    )}
                </WalkmePopupWrapper>
            </div>
            {isCreatingRule && <CreateRuleBoxWrapper handleClose={() => setIsCreatingRule(false)} />}
        </div>
    );
}
